import { StyledDialog, Transition } from "./styles";
import { StyledDialogTitle } from "./StyledDialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import { ReactElement } from "react";
import AppButton, { AppButton2, AppButton3 } from "./AppButton";

interface IProps {
  title: string;
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  children: ReactElement | ReactElement[];
  maxWidth?: any;
  isLoading?: boolean;
}

export default function AppConfirmationDailog({
  title,
  open,
  handleClose,
  children,
  maxWidth = "md",
  handleConfirm,
  isLoading,
}: IProps) {
  return (
    <StyledDialog
      open={open}
      maxWidth={maxWidth}
      TransitionComponent={Transition}
    >
      <StyledDialogTitle id="customized-dialog-title" onClose={handleClose}>
        {title}
      </StyledDialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions>
        <AppButton2 title="Cancel" onClick={handleClose} />
        {isLoading ? (
          <AppButton3 />
        ) : (
          <AppButton title="Ok" onClick={handleConfirm} />
        )}
      </DialogActions>
    </StyledDialog>
  );
}
